import { shortMonthNames } from '../constants/month';

export const getDateAsString = (date) => {
  return date.getDate()
    + ' '
    + shortMonthNames[date.getMonth()]
    + ' '
    + date.getFullYear();
}

export const getTimeAsString = (time) => {
  const date = new Date(time * 1000);
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const seconds = date.getSeconds();
  const toRemoveFromTime = seconds + minutes * 60 + hours * 3600;
  const days = (time - toRemoveFromTime) / 86400;
  let result = '';
  if (days > 0) {
    result += days + 'j - ';
  }
  result += hours + ':';
  result += (minutes < 10 ? '0' : '') + minutes + ':';
  result += (seconds < 10 ? '0' : '') + seconds;
  return result;
}

export const getDayFirstSecondeDate = () => {
  let start = new Date();
  start.setHours(0, 0, 0, 0);
  return start;
}

export const getDayLastSecondeDate = () => {
  let end = new Date();
  end.setHours(23, 59, 59, 999);
  return end;
}

export const getActualTimestamp = () => {
  return Math.round((new Date()).getTime() / 1000);
}



// WEBPACK FOOTER //
// ./src/services/DateService.js